// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__W4aU7","title":"ClientReferral_title__3N2Ew","itemText":"ClientReferral_itemText__e3C5e"};